export default __webpack_public_path__ + "static/b-12-3d618f177d3f6cbc071a51fe68d9182c.jpg";